import { Routes } from '@angular/router';
import { authGuard } from '#core';
import { UserRole } from '#enums';
import { ForbiddenComponent, NotFoundComponent, ServerErrorComponent, UnauthorizedComponent } from '#components';
import { WorkflowInboxComponent } from '../features/workflow-inbox/workflow-inbox.component';
import { NetworkDynamicComponent } from '../features/network/network-dynamic.component';
import { AgentRunsComponent } from '../features/agent-runs/agent-runs.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    data: { roles: [UserRole.User] },
    component: WorkflowInboxComponent,
    pathMatch: 'full',
  },
  {
    path: 'network',
    redirectTo: 'network-dynamic',
    pathMatch: 'full',
  },
  {
    path: 'network-dynamic',
    canActivate: [authGuard],
    data: { roles: [UserRole.User] },
    component: NetworkDynamicComponent,
  },
  {
    path: 'agent-runs',
    canActivate: [authGuard],
    data: { roles: [UserRole.User], title: 'Agent Runs' },
    component: AgentRunsComponent,
  },
  {
    path: '401',
    component: UnauthorizedComponent,
  },
  {
    path: '403',
    component: ForbiddenComponent,
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '500',
    component: ServerErrorComponent,
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
